import { useGetList } from "#hooks/adapters/adapterUtils";
import { Resources, RolesAdapter } from "@validereinc/domain";

export const useListRoles = useGetList(RolesAdapter.getList, Resources.ROLE);
